import { render, staticRenderFns } from "./ThirdStepModalMail.vue?vue&type=template&id=29570d2a&"
import script from "./ThirdStepModalMail.vue?vue&type=script&lang=js&"
export * from "./ThirdStepModalMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports